module.exports = __webpack_public_path__ + "img/switzerland-tuberculosis-male.a80d534f.png";